import { useTranslation } from "../i18n";
import WipeAdmin from "../components/WipeAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminWipe = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="wipe_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "wipe_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("wipe_admin_hint")}</p>
                <WipeAdmin />
            </div>
        </div>
    );
};

export default AdminWipe;
